import { useCart } from 'contexts/CartContext/CartContext.hooks';
import { useEffect, useMemo, useState } from 'react';
import { IAssurance, IAssurancePriceRange } from 'types/Assurance';
import { GetAssurance } from '../../../api/Assurance/Assurance.api';

export const useCalcAssurance = (retailPrice?: number) => {
    const { cart } = useCart();

    const [assurance, setAssurance] = useState<IAssurance>();

    useEffect(() => {
        if (!assurance) {
            GetAssurance(setAssurance, () => console.log('failed to find assurance'));
        }
    }, [retailPrice]);

    const getPriceRangeIndex = () => {
        if (!assurance || !retailPrice) return 0;

        for (let i = 0; i < assurance.priceRanges.length; i++) {
            if (retailPrice < assurance.priceRanges[i].upperLimit) return i;
        }

        return assurance.priceRanges.length - 1;
    };

    const range: IAssurancePriceRange = useMemo(() => {
        if (!assurance || !retailPrice) {
            return {
                upperLimit: 0,
                replacementCharge: 0,
                lineSkus: []
            };
        }

        const index = getPriceRangeIndex();

        return assurance.priceRanges[index];
    }, [cart.lineItems.length, assurance?.priceRanges, retailPrice]);

    const sku = useMemo(() => {
        const numLines = cart.lineItems.length == 0 ? 1 : cart.lineItems.length;
        const costs = range?.lineSkus;

        if (!costs) return undefined;

        return costs.length < numLines ? costs[costs.length - 1] : costs[numLines - 1];
    }, [range?.lineSkus, range?.lineSkus?.length, cart.lineItems.length]);

    const replacementCharge = useMemo(() => {
        return range?.replacementCharge ?? 0;
    }, [range]);

    return { sku, replacementCharge, assurance };
};
